import { Injectable } from '@angular/core';
import {
  BrowserXhr,
  CookieXSRFStrategy,
  Headers,
  Http,
  RequestOptions,
  ResponseOptions,
  XHRBackend,
} from '@angular/http';
import { BodyOutputType, Toast, ToasterConfig } from 'angular2-toaster';
import { ServerDataSource } from 'ng2-smart-table';
import { ServerSourceConf } from 'ng2-smart-table/lib/data-source/server/server-source.conf';

@Injectable()
export class Globals {
  // constructor() {
  //   console.log('[Globals] Created')
  // }

  position = 'toast-top-right';
  animationType = 'fade';
  // title = 'HI there!';
  // content = `I'm cool toaster!`;
  timeout = 10000;
  toastsLimit = 5;
  // type = 'default';

  isNewestOnTop = true;
  isHideOnClick = true;
  isDuplicatesPrevented = false;
  isCloseButton = true;

  config = new ToasterConfig({
    positionClass: this.position,
    timeout: this.timeout,
    newestOnTop: this.isNewestOnTop,
    tapToDismiss: this.isHideOnClick,
    preventDuplicates: this.isDuplicatesPrevented,
    animation: this.animationType,
    limit: this.toastsLimit,
  });

  getToast(type: string, title: string, content: string): Toast {
    const toast: Toast = {
      type,
      title,
      body: content,
      timeout: this.timeout,
      showCloseButton: this.isCloseButton,
      bodyOutputType: BodyOutputType.TrustedHtml,
    };
    return toast;
  }

  createServerDataSource(endpoint) {
    // Create Smart Table
    // https://github.com/akveo/ng2-smart-table/issues/614

    const serverSourceConf = new ServerSourceConf({
      endPoint: endpoint,
      totalKey: 'total',
      dataKey: 'data',
    });

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Authorization', localStorage.getItem('access_token'));
    const myOptions = new RequestOptions({ headers });
    const myConnection = new XHRBackend(new BrowserXhr(), new ResponseOptions(), new CookieXSRFStrategy());
    const myHttp = new Http(myConnection, myOptions);
    return new ServerDataSource(myHttp, serverSourceConf);
    //  TODO: Handle Smart Table errors
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/globals.ts